import MuiBox, {BoxProps} from '@mui/material/Box';
import {forwardRef} from 'react';

export type {
    BoxProps
};

export const Box = forwardRef<unknown, BoxProps>((boxProps, ref) => (
    <MuiBox
        {...boxProps}
        ref={ref}
    />
));
Box.displayName = 'Box';
